
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/epoch/register",
      function () {
        return require("private-next-pages/epoch/register.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/epoch/register"])
      });
    }
  